import React, { useContext } from "react";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";
import InterestFormRow from "./InterestFormRow";
import * as FaIcons from "react-icons/fa";

const headers = [
  { name: "createdAt", display: "Submit Date" },
  { name: "learningCenterName", display: "Learning Center" },
  { name: "studentFirstName", display: "Student Name" },
  { name: "age", display: "Age" },
  { name: "parentRelationship", display: "Relationship" },
  { name: "phone", display: "Phone" },
  { name: "primaryEmail", display: "Email" },
  { name: "status", display: "Status"},
  { name: "lastContactDate", display: "Last Contact Date" },
  // { name: "campaign", display: "Campaign" },
  { name: "Permalink", display: "Permalink" },
];

const TableHeaderItem = ({ name, display }) => {
  const adminInterestContext = useContext(AdminInterestContext);
  const { sortOptions, onTableFilter } = adminInterestContext;
  
  // Safety check to ensure sortOptions[name] exists
  const sortOption = sortOptions[name] || { asc: false, desc: false };
  
  return (
    <th onClick={() => onTableFilter(name)}>
      <div className="wrap">
        <span>{display}</span>
        <div className="filter">
          <FaIcons.FaSortUp
            style={{
              color: sortOption.asc ? "#343434" : "white",
            }}
          />
          <FaIcons.FaSortDown
            style={{
              color: sortOption.desc ? "#343434" : "white",
            }}
          />
        </div>
      </div>
    </th>
  );
};

const InterestTable = ({ items }) => {
  const adminInterestContext = useContext(AdminInterestContext);
  const { ageOver, visibleColumns } = adminInterestContext;

  // Filter headers based on visibility
  const visibleHeaders = headers.filter(header => {
    // Check if column is visible in context
    if (visibleColumns && visibleColumns[header.name] === false) {
      return false;
    }
    // Keep existing ageOver logic
    if (ageOver && header.name === "parentRelationship") {
      return false;
    }
    return true;
  });

  return (
    <div className="interest-form-table">
      <div className="table-responsive">
        <table className="responsive-table" id="interest-table">
          <thead>
            <tr>
              {visibleHeaders.map((header) => (
                <TableHeaderItem key={header.name} name={header.name} display={header.display} />
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              return <InterestFormRow key={item._id} info={item} visibleColumns={visibleColumns} />;
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default InterestTable;
